<template>
  <div class="col px-0 contact d-flex flex-column">
    <div class="content-title mb-5">
      <div class="media">
        <div class="media-body">
          <h1>
            {{ $t("feature.greeting.title") }}
          </h1>
          <div class="alert alert-warning download-report-message mb-2">
            เลือก ช่วงเวลา ที่ต้องการก่อนกด Download Report
          </div>
          <div class="row">
            <div class="ml-3">
              <el-date-picker
                class="date-picker"
                :value="dateTimeReport"
                @input="handleChangeDate($event)"
                type="daterange"
                range-separator="ถึง"
              ></el-date-picker>
            </div>
            <div class="ml-3">
              <sc-button
                variant="secondary"
                @click="handleClickDownloadReport"
              >Download Report</sc-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <router-view></router-view>
  </div>
</template>
<script>
import { DatePicker } from "element-ui";
import Breadcrumbs from "./Breadcrumbs";
import ScButton from "@/lib/components/ScButton";
import { DateTime } from "luxon";
import { baanRueJaiClient } from "@/dependencies";

export default {
  components: {
    Breadcrumbs,
    ScButton,
    "el-date-picker": DatePicker
  },
  data() {
    const selectedDateTimeReport = null;

    return {
      selectedDateTimeReport
    };
  },
  computed: {
    dateTimeReport() {
      if (!this.selectedDateTimeReport) {
        return null;
      }

      const { from, to } = this.selectedDateTimeReport;

      return [from.setZone("local").toJSDate(), to.setZone("local").toJSDate()];
    }
  },
  methods: {
    handleChangeDate(value) {
      if (!value) {
        this.selectedDateTimeReport = null;
        return;
      }
      const [fromJSDate, toJSDate] = value;
      const from = DateTime.fromJSDate(fromJSDate).startOf("day").toUTC();
      const to = DateTime.fromJSDate(toJSDate)
        .endOf("day")
        .toUTC();

      this.selectedDateTimeReport = { from, to };
    },
    async handleClickDownloadReport() {
      const { from, to } = this.selectedDateTimeReport;
      const greetingCategory = 4;

      try {
        const response = await baanRueJaiClient.admin.greeting.getReport(
          {
            start_at: from.toISO(),
            end_at: to.toISO(),
            contact_category_id: greetingCategory
          }
        );

        const blob = new Blob([response.data]);
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = `report-greeting-${from.toISODate()}-${to.toISODate()}.xlsx`;
        link.click();
      } catch(error) {
        // TODO: use alert message from response message backend
        alert("ไม่สามารถ Download Report ได้ เนื่องจากไม่มีข้อมูลหรือเกิดข้อผิดพลาด");
        console.error(error);
      }
    }
  },
  created() {}
};
</script>

<style lang="scss" scoped>
.download-report-message {
  font-size: 15px;
}
</style>


// WEBPACK FOOTER //
// src/components/admin/layout/GreetingLayout.vue